import { Col, Row } from 'antd';
import SlideIn from 'components/SlideIn';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const StatusTextStyled = styled.span<{ color?: string }>`
  color: ${({ color }) => color || 'black'};
`;

export const NestedScheduleContainerStyled = styled.div`
  padding: 19px 35px 16px;
`;

export const ScheduleHeaderStyled = styled.span`
  font-size: 18px;
  font-weight: 600;
`;

export const SlideInStyled = styled(SlideIn)`
  .transaction-form-container {
    padding: 0;
  }
  .fields-container {
    width: 100% !important;
    max-width: 100% !important;
  }
`;

export const TitleContainerStyled = styled.div`
  padding: 20px 10px 10px;
  display: flex;
  flex-wrap: nowrap;
  @media screen and (max-width: ${breakpoints.sm}) {
    flex-wrap: wrap;
    flex-direction: column;
  }
`;

export const TitleLeftSideContainerStyled = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

export const TitleTextContainerStyled = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;

export const SlideInTitleButtonsContainerStyled = styled(Row)`
  margin: 0;
  min-width: 270px;
  flex: 1;
  justify-content: flex-end;
  & > * {
    margin-left: 10px;
  }
  @media screen and (max-width: ${breakpoints.sm}) {
    justify-content: flex-start;
    margin-top: 10px;
    & > * {
      margin-left: 0;
    }
  }
`;

export const TitleButtonContainerStyled = styled(Col)``;

export const TransactionDetailedOnlyWrapper = styled.div`
  margin: 0 -16px;
  & > * {
    padding-bottom: 1.5rem;
  }
  .submit-transaction-button-container {
    display: none;
  }
`;
